/**
 * **"What this person may do may have changed"** — fired by the API client when
 * a request is refused with `PERMISSION_REQUIRED`, so the permissions the
 * screens draw from are read again. Without it a role taken away left an open
 * tab offering controls the server then refused, and a role given kept
 * redirecting away from a page until a reload. The modules' twin is
 * `MODULES_CHANGED`.
 */
export const ACCESS_CHANGED = "dentacore:access-changed";

export function announceAccessChanged(): void {
  window.dispatchEvent(new Event(ACCESS_CHANGED));
}
